import BaseComponent from "../../../js/base-component";

class SearchHeader extends BaseComponent {

    constructor(options) {
        super(options);

        let box = document.querySelector(".u-search-header"),
            closebox = document.querySelector(".u-search-header__button"),
            header = document.querySelector(".u-header"),
            searchToggle = document.querySelector(".u-search-header__toggle"),
            searchfield = document.querySelector(".u-search-header__field"),

        //methods
        setup = function () {
            searchToggle.addEventListener("click", open);
            searchfield.addEventListener("input", ajaxsearch);
        },
        close = function (evt) {
            evt.preventDefault();

            header.classList.remove("is-active--searchfield");
            closebox.removeEventListener("click", close);
            searchToggle.removeEventListener("click", close);
            document.removeEventListener("click", globalclose);
        },
        globalclose = function (evt) {
            if ( !box.contains(evt.target) || closebox.contains(evt.target) ) {
                evt.preventDefault();

                close(evt);
            }
        },
        open = function (evt) {
            evt.preventDefault();
            header.classList.add("is-active--searchfield");

            searchfield.focus();

            box.removeEventListener("click", open);
            closebox.addEventListener("click", close);
            searchToggle.addEventListener("click", close);
            document.addEventListener("click", globalclose);
        },
        ajaxsearch = function(evt) {
            if (evt.target.value.length > 2) {
                fetch(`/api/ajax/search?pattern=${evt.target.value}`)
                    .then(response => response.json())
                    .then(results => showResults(results))
                    .catch(error => console.log('error', error));
            }
        },
        showResults = function(results) {
            let resultsContainer = document.querySelector('.u-search-header__results');
            let resultsObj = {};

            if (typeof results.success !== 'undefined' && results.success === true) {
                let jsonData = results.data;

                resultsObj = '<ul class="u-search__results-list">';

                if (jsonData.results > 0) {
                    if (jsonData.items.length) {
                        jsonData.items.forEach((item) => {
                            resultsObj += `<li class="u-search-result__entry u-search-result__item">
                                    <a class="u-search-result__link" href="${item.link.href}" title="${item.link.text}" target="${item.link.target}">
                                        <span class="u-search-result__media">
                                            ${item.image}
                                        </span>
                                        <span class="u-search-result__name">${item.name}</span>
                                    </a></li>`
                        });
                    }
                    resultsObj += `<li class="u-search-results-all u-search__result__item">`;

                    if (jsonData.linkAll) {
                        resultsObj += `<a href="${jsonData.linkAll.href}" target="${jsonData.linkAll.target}" class="u-search-result__link u-search-results-all__link">
                        ${jsonData.linkAll.text}
                        <i class="seeger-icon--arrow-right"></i></a>`;
                    }

                    resultsObj += `<span class="u-search-results-all__number">${jsonData.results} Treffer</span></li>`;

                } else {

                    resultsObj += `<li class="u-search-result__entry u-search-result__entry--no-results u-search-result__item">Keine Suchergebnisse gefunden</li>`;
                }

                resultsObj += '</ul>';

                resultsContainer.innerHTML = resultsObj;

                resultsContainer.classList.add('is--active');
            }
        };

        if (box) {
            setup();
        }
    }
}

export default {
    definition: SearchHeader,
    name: "SearchHeader",
};
